import { render, staticRenderFns } from "./PaywallV1.vue?vue&type=template&id=34d58a89&scoped=true"
import script from "./PaywallV1.vue?vue&type=script&lang=js"
export * from "./PaywallV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d58a89",
  null
  
)

export default component.exports